import { useBreakpointValue } from "@gluestack-style/react";
import { View } from "components/ui";
import React from "react";
import { useWindowDimensions } from "react-native";

type Props = {
	children: React.ReactNode | React.ReactNode[];
	sx?: any;
	isMainContainer?: boolean;
	isFit?: boolean;
	noMargin?: boolean;
	noPadding?: boolean;
};

const Container = ({ children, sx, isMainContainer, isFit, noMargin, noPadding }: Props) => {
	const { width: windowWidth } = useWindowDimensions();
	const contentStyle = useBreakpointValue({
		base: {
			marginTop: 0,
			flex: 1,
			marginLeft: "auto",
			marginRight: "auto",
			width: "100%",
		},
		md: { width: "100%", marginHorizontal: "auto", paddingHorizontal: 20 },
		lg: { width: "100%", marginHorizontal: "auto", paddingHorizontal: 20 },
		xl: {
			width: "100%",
			maxWidth: isMainContainer ? "100%" : isFit ? 1692 : 1728,
			marginHorizontal: noMargin ? "" : "auto",
			paddingLeft: isMainContainer ? 0 : noPadding ? 0 : 20,
			paddingRight: noPadding ? 0 : 0,
		},
	});

	return (
		<View sx={sx} style={contentStyle}>
			{children}
		</View>
	);
};

export default Container;
